import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, useTheme, Grid, Paper, Button } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const UserDetails = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = location.state || {};

  if (!user) {
    return <Typography>User not found</Typography>;
  }

  const handleBack = () => {
    navigate(-1);
  };

  const renderDetailItem = (label, value) => (
    <Grid item xs={12} sm={6} md={4}>
      <Typography><strong>{label}:</strong> {value ?? 'N/A'}</Typography>
    </Grid>
  );

  return (
    <Box m="20px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header
          title="USER DETAILS"
          subtitle={`Viewing details for ${user.username ?? 'Unknown User'}`}
        />
        <Button
          variant="contained"
          color="secondary"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
        >
          Back to Users List
        </Button>
      </Box>
      <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={4}>
          <Paper elevation={3} sx={{ p: 2, bgcolor: colors.primary[400] }}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={2}
            >
              <img
                src={user.profile?.profile_image ? `https://cheebo-server.neuralbey.com${user.profile.profile_image}` : "/default-avatar.png"}
                alt={`${user.username ?? 'User'}'s profile`}
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '50%',
                  objectFit: 'cover'
                }}
              />
            </Box>
            <Typography variant="h4" textAlign="center" color={colors.greenAccent[300]}>
              {user.username ?? 'N/A'}
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper elevation={3} sx={{ p: 2, bgcolor: colors.primary[400] }}>
            <Typography variant="h5" color={colors.greenAccent[300]} mb={2}>User Information</Typography>
            <Grid container spacing={2}>
              {renderDetailItem("ID", user.id)}
              {renderDetailItem("Username", user.username)}
              {renderDetailItem("First Name", user.first_name)}
              {renderDetailItem("Last Name", user.last_name)}
              {renderDetailItem("Email", user.email)}
              {renderDetailItem("Is Superuser", user.is_superuser?.toString())}
              {renderDetailItem("Is Staff", user.is_staff?.toString())}
              {renderDetailItem("Is Active", user.is_active?.toString())}
              {renderDetailItem("Date Joined", user.date_joined ? new Date(user.date_joined).toLocaleString() : 'N/A')}
              {renderDetailItem("Last Login", user.last_login ? new Date(user.last_login).toLocaleString() : 'Never')}
              {renderDetailItem("Groups", user.groups?.length > 0 ? user.groups.join(', ') : 'None')}
              {renderDetailItem("User Permissions", user.user_permissions?.length > 0 ? user.user_permissions.join(', ') : 'None')}
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 2, bgcolor: colors.primary[400] }}>
            <Typography variant="h5" color={colors.greenAccent[300]} mb={2}>Profile Information</Typography>
            <Grid container spacing={2}>
              {renderDetailItem("Profile ID", user.profile?.id)}
              {renderDetailItem("Phone Number", user.profile?.phone_number)}
              {renderDetailItem("Address", user.profile?.profile_address)}
              {renderDetailItem("Bio", user.profile?.bio)}
              {renderDetailItem("Country", user.profile?.country)}
              {renderDetailItem("City", user.profile?.city)}
              {renderDetailItem("Device Type", user.profile?.device_type)}
              {renderDetailItem("Device Token", user.profile?.device_token)}
              {renderDetailItem("Role", user.profile?.role)}
              {renderDetailItem("Profile Active", user.profile?.is_active?.toString())}
              {renderDetailItem("Profile Owner ID", user.profile?.profile_owner)}
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserDetails;